import { Navigate } from "react-router-dom";

const CallCenterTicketColumnsPage = () => (
  <Navigate to="/call-center/ticket-settings?tab=columns" replace />
);

export default CallCenterTicketColumnsPage;
